import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  memo,
} from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useI18n } from '@/hooks/useLocale'
import { useMountedState } from '@/hooks/useMountedState'
import { useDispatch, useSelector } from 'react-redux'
import {
  getClientHeight,
  getClientWidth,
  getMenuCollapse,
  getSettings,
  trigger,
  watchEvent,
} from '@/store/slices/appSlice'
import { getConfiguration } from '@/store/slices/userSlice'
import { usePermission } from '@/hooks/usePermission'
import axios from 'axios'
import {
  InitCardTitle,
  cloneDeep,
  findTreeItem,
} from '@/utils/tools'
import {
  Button,
  Card,
  Layout,
  Message,
  Notification,
  Upload,
} from '@arco-design/web-react'
import { CommonConfirm, CommonTable, ToolPanel } from '..'
import {
  IconDelete,
  IconExport,
  IconImport,
  IconPlus,
  IconRefresh,
  IconSave,
} from '@arco-design/web-react/icon'
import { SearchPanel } from '../SearchPanel'
import getUrlParams from '@/utils/getUrlParams'
import ContexMenu from '../ContexMenu'
import QS from 'qs'
import useStorage from '@/hooks/useStorage'
import { baseUrl, getSetting } from '@/utils/settings'
function _LoongInCommonIndex (
  {
    columns, //列定义
    getList, //获取数据endpoint
    getGetListInput, //获取数据调用接口传递的参数
    requestGetList,
    deleteData, //删除数据endpoint
    getDeleteInput, //获取删除参数输入
    requestDelete,
    FormEdit, //编辑窗口
    formRoute: currFormRoute, //'baseData/material/list'
    dynamicFormRoute = false, //是否动态formRoute
    otherMenu, //其他菜单
    searchItem, //查询项
    searchInitData = {}, //初始查询数据
    searchData, //查询数据
    searchEvent, //
    onSearchDataChange, //查询数据变化时
    enableQueryOnSearchDataChange, //开启searchData变化时刷新，默认开启
    toolChildren, //工具栏其他按钮
    actionRender, //自定义操作列
    canShow, //是否可以查看
    canAdd, //是否可以添加数据
    canEdit, //是否可以编辑
    canDelete, //是否可以删除
    canBatchDel, //是否可以批量删除
    canOutput, //是否可以输出
    canInport, //是否可以导入
    onChangeData, //data修改时触发
    onUpdate, //更新后台
    onDeleteData, //删除时触发
    onBatchDeleteData, //批量删除时触发
    refreshAfterDelete, //删除后是否刷新列表
    enableSorting, //开启排序功能
    leftPanelWidth, //左侧宽度
    leftPanel, //左侧插槽
    rightPanelWidth, //右侧宽度
    rightPanel, //右侧插槽
    siderHeight, //左右侧高度
    showPage = true, //是否显示分页
    pageSize = 10, //表格每页行数大小
    refreshWhenOpen, //打开时刷新数据
    wrapHeight, //外部高度
    tableHeight, //表格高度
    tableWidth, //表格宽度
    tableSize, //表格尺寸
    tableHeightNoControl, //不控制表格高度
    className, //样式类
    searchClassName, //查询样式
    toolClassName, //工具栏样式
    canSelection, //是否开启选择功能
    onSelectionChange, //选择改变时触发
    onAdd, //点击添加按钮时触发，用于进行添加前的动作，传入回调方法
    onAddBefore, //添加按钮点击后触发，如果返回item则会setFormData(item)
    onEdit, //点击编辑按钮时触发
    onShow, //点击查看按钮时触发
    tools, //工具自定义
    toolWidth, //工具栏宽度
    hasHeader = true, //是否有头部
    renderCustomerHeader, //自定义头部
    canSearch, //是否可以查询
    multipleChoice = true, //是否开启多选，默认是多选
    extraData, //其他需传递的数据
    getResult, //获取结果集
    keyField = 'id', //主键字段名
    titleField = '', //显示在页签上的标签字段名
    checkCanDelete, //检查当前行是否可删除
    checkCanEdit, //检查当前行是否可编辑
    checkCanShow, //检查当前行是否可查看
    formDisabled, //窗口是否可修改
    simpleSearch = true, //默认显示简易查询还是复杂查询
    triggerGetResult, //触发获取结果
    lazySetList = false, //延迟设置list
    onClick, //单击事件，传入参数(item,index,event)
    onDoubleClick, //双击事件，传入参数(item,index,event)
    contextMenu, //右键菜单[{title:'',color:'',onClick:(item)=>void,disabled:false}]
    defaultContextMenuDisable, //禁用默认右键菜单
    showSearchButton = true, //是否显示查询按钮
    highlightRow, //是否将当前行高亮
    operationCol,
    tableProps,
    renderSumary,
    searchLabelCol,
    searchWrapperCol,
    ensureDidMount,
    needNum, //是否需要序号
    onExpand,
    expandedRowKeys,
    checkboxProps,
    noUrlQuery = false,
    permission = '',
    onOperateButtonCount, //传递按钮数量
    sizeOptions, //页容量
    canRefresh, //刷新按钮
    showOperationCol = true, //是否开启操作列，默认开启,
    useUrlQuery = true, //使用url的参数
    viewHeight, //适口高度,
    onAddCustomTitle, //自定义ADDtabs title
    onEditCustomTitle, //自定义EDITtabs title
    onShowCustomTitle, //自定义SHOWtabs title
    bordered = true, //是否显示边框
    hoverable = true, //是否开启鼠标悬停
    canSave, //是否可保存
    onSave, //保存事件
    searchPanelSize = 'small', //查询面板大小
    title, //标题
    compensateHeight = 0, //补偿高度
    bodyStyle = {}, //card bodyStyle
    simpleSearchInputWidth, // 简单查询输入框的width
    onRowCheckClick,
    useRowCheckClick,
    cardSize = 'default', //卡片大小
    searchFields, //搜索查询字段  不传递就是filter
    searchPlaceholder,
    canEditText,
    canShowText,
    simpleSearchProps = {}, //简单查询props
    requestType = 'GET', //请求方式
    batchDeleteRequestType = 'delete',
    onOutput, //导出
    extendUrlParams, //请求地址上的参数
    paginationSimple = false, //简洁分页
    paginationSizeCanChange = true, //分页大小是否可变
    requestBatchDelNoFor = false, //批量删除不for
    checkCanBatchDel,
    simpleSearchVal = '', //简单查询值
    directions = ['right'],
    getListError,
    queryFormRoutes = [],
    footer,
    footerHeight = 0,
    canUpload, //文件上传
    onSelectionChangeBefore,
    locale=[], //locale
    dynamicDetailRoute = false, //开启动态详情页跳转
    dynamicDetailRouteKey, //动态详情页父路由，默认使用当前列表路由
    dynamicDetailActions = {}, //动态详情页动作映射：{ add, edit, show }
  },
  ref
) {
  const HeadHeightRef = useRef(null)
  const t = useI18n()
  const settings = useSelector(getSettings)
  const urlParams = getUrlParams()
  const menuWidth = settings.menuWidth
  const showNavbar = settings.navbar && urlParams.navbar !== false
  const showFooter = settings.footer && urlParams.footer !== false
  const tableHeightControl = tableHeightNoControl
    ? false
    : settings.tableHeightControl && urlParams.tableHeightControl !== false
  const appEvent = useSelector(watchEvent)
  const isMounted = useMountedState()
  const [formEvent, setFormEvent] = useState(null)
  const [clientHeight, setClientHeight] = useState(useSelector(getClientHeight))
  const appClientHeight = useSelector(getClientHeight)
  const clientWidth = useSelector(getClientWidth)
  const [keyword, setKeyword] = useState('')
  const history = useHistory()
  const location = useLocation()
  const urlQuery = new URLSearchParams(location.search)
  const [pageIndex, setPageIndex] = useState(1)
  const [currentPageSize, setCurrentPageSize] = useState(pageSize)
  const [list, setList] = useState([])
  const [listCount, setListCount] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [activDataIndex, setActivDataIndex] = useState('')
  const [formData, setFormData] = useState(null)
  const [sort, setSort] = useState(undefined)
  const [deleteItem, setDeleteItem] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [checkItems, setCheckItems] = useState([])
  const [showBatchDel, setShowBatchDel] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [showKeyword, setShowKeyword] = useState(simpleSearch)
  const dispatch = useDispatch()
  const configuration = useSelector(getConfiguration)
  const [result, setResult] = useState(null)
  const menuCollapsed = useSelector(getMenuCollapse)
  const [innerLeftSiderWidth, setInnerLeftSiderWidth] = useState(-1)
  const [innerRightSiderWidth, setInnerRightSiderWidth] = useState(-1)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [tableHeadHeight, setTableHeadHeight] = useState(40)
  const [headHeight, setHeadHeight] = useState(40)
  const [curContextMenu, setCurContextMenu] = useState([])
  const [contextMenuState, setContextMenuState] = useState({
    visible: false,
    top: 0,
    left: 0,
  })
  const defaultContextMenu = []
  const KEY_TOKEN_LOGIN = getSetting('KEY_TOKEN_LOGIN')
  const [token, , removeToken] = useStorage(KEY_TOKEN_LOGIN)
  const apiBaseUrl = baseUrl()
  //2024-05-07 新增动态formRoute
  //开始
  const [formRoute, setFormRoute] = useState(currFormRoute)
  useEffect(() => {
    if (!dynamicFormRoute) return
    let pathList = location.pathname.split('/')
    pathList.splice(0, 1)
    pathList.splice(pathList.length - 1, 1)
    pathList.push('detail')
    let resRoute = pathList.join('/')
    setFormRoute(resRoute)
  }, [dynamicFormRoute])
  //结束

  //当前列表路由
  const [listRoute, setListRoute] = useState('')
  useEffect(() => {
    setListRoute(location.pathname.slice(1))
  }, [])
  const getDynamicDetailRouteKey = () =>
    dynamicDetailRouteKey || formRoute || listRoute || location.pathname.slice(1)
  const getDynamicDetailAction = (type) => {
    const defaultActions = {
      add: 'create',
      edit: 'edit',
      show: 'view',
    }
    return dynamicDetailActions[type] || defaultActions[type]
  }
  const openDynamicDetail = (action, item = {}, options = {}) => {
    const targetItem = item?.isEvent ? {} : item || {}
    const isCreateAction = action === getDynamicDetailAction('add')
    const isShowAction = action === getDynamicDetailAction('show')
    const data = {
      id: options.id ?? (isCreateAction ? '' : targetItem?.[keyField] ?? ''),
      formData: options.formData ?? (isCreateAction ? targetItem : item),
      event: null,
      disabled: options.disabled ?? isShowAction,
    }
    if (dynamicDetailRoute) data.action = action
    if (options.customTitle) {
      data.customTitle = options.customTitle
    } else if (options.title) {
      data.title = options.title
    } else if (titleField && targetItem?.[titleField]) {
      data.title = targetItem[titleField]
    }
    if (!dynamicDetailRoute) {
      if (!formRoute) return
      dispatch(
        trigger({
          name: 'history.push',
          params: formRoute,
          data,
        })
      )
      return
    }
    dispatch(
      trigger({
        name: 'history.push',
        params: getDynamicDetailRouteKey(),
        data,
      })
    )
  }

  useEffect(() => {
    if (!simpleSearch) return
    setKeyword(simpleSearchVal)
  }, [simpleSearchVal])

  useEffect(() => {
    if (viewHeight) {
      setClientHeight(viewHeight)
    }
  }, [viewHeight])
  useEffect(() => {
    if (appClientHeight) {
      setClientHeight(appClientHeight)
    }
  }, [appClientHeight])
  useEffect(() => {
    if (appEvent && appEvent.name && appEvent.name.indexOf('/onSubmit') >= 0) {
      let formroute = formRoute
      if (formRoute instanceof Array) {
        if (formRoute.findIndex((c) => c == appEvent.formRoute) >= 0) {
          formroute = appEvent.formRoute
        }
      }
      /**
       * 列表页刷新
       * 取出formData中的refreshRoute
       * 判断组件的列表页地址是否为当前的地址，刷新数据
       * 若refreshRoute为空数组，则刷新全部的列表页数据
       *
       */
      let refreshRoute = appEvent?.formData?.refreshRoute
      if (
        refreshRoute &&
        listRoute &&
        (refreshRoute?.includes(listRoute) || refreshRoute?.length == 0)
      ) {
        query()
        return
      }
      let newQueryFormRoutes = queryFormRoutes.map((str) => {
        return str + '/onSubmit'
      })
      if (
        appEvent.name == formroute + '/onSubmit' ||
        newQueryFormRoutes.includes(appEvent.name)
      ) {
        query()
      }
    }
  }, [appEvent, formRoute])

  useEffect(() => {
    let menu = defaultContextMenuDisable ? [] : defaultContextMenu
    if (contextMenu) {
      setCurContextMenu([...menu, ...contextMenu])
    } else {
      setCurContextMenu([...menu])
    }
  }, [contextMenu, defaultContextMenuDisable])

  const pagePermission = usePermission(permission)
  const permCreate = pagePermission.Create
  const permDelete = pagePermission.Delete
  const permUpdate = pagePermission.Update
  const permList = pagePermission.GetList
  useEffect(() => {
    if (!isMounted()) return
    setCurrentPageSize(pageSize)
  }, [pageSize])

  const changeList = async (data) => {
    const items = getResult ? await getResult(data) : data?.items || data?.data
    setList(() => {
      return items
    })
    _onSelectionChange([])
    onChangeData && onChangeData(items)
    setListCount(data.totalCount || items.length)
    clearSelected()
  }
  const fetchData = async (param) => {
    let params = {
      ...param,
    }
    if (!getList) return
    setIsLoading(true)
    const fetchParams = getGetListInput ? await getGetListInput(params) : params
    if (fetchParams === null) return
    const finallyFunc = (e) => {
      if (!isMounted()) return
      setIsLoading(false)
    }
    let e
    if (!requestGetList) {
      if (requestType == 'GET') {
        e = await axios
          .get(getList() + (extendUrlParams ?? ''), {
            params: fetchParams,
            paramsSerializer: function (params) {
              return QS.stringify(params, { arrayFormat: 'repeat' })
            },
          })
          .finally(finallyFunc)
          .catch((e) => {
            Notification.error({
              title: t('t_remind'),
              content:
                e && e.error && e.error.message
                  ? e.error.message
                  : t('t_failToGetData'),
              showIcon: true,
              position: 'bottomRight',
              duration: 1500,
            })
            getListError && getListError()
          })
      } else {
        e = await axios
          .post(getList() + (extendUrlParams ?? ''), fetchParams)
          .finally(finallyFunc)
          .catch((e) => {
            Notification.error({
              title: t('t_remind'),
              content:
                e && e.error && e.error.message
                  ? e.error.message
                  : t('t_failToGetData'),
              showIcon: true,
              position: 'bottomRight',
              duration: 1500,
            })
            getListError && getListError()
          })
      }
    } else {
      e = await requestGetList(fetchParams).finally(finallyFunc)
    }
    if (!isMounted()) {
      return
    }
    if (e?.data || e?.items) {
      setResult(e?.data)
      if (!lazySetList) changeList(e?.data)
    }
  }
  useEffect(() => {
    if (!isMounted()) return
    if (triggerGetResult && result) {
      changeList(result)
    }
  }, [result, triggerGetResult])
  useEffect(() => {
    if (!isMounted()) return
    if (activDataIndex && list && list.length > 0) {
      const item = findTreeItem(list, keyField, activDataIndex)
      setFormData(item)
    }
  }, [list, activDataIndex])
  useEffect(() => {
    if (!isMounted()) return
    ensureDidMount && ensureDidMount()
    if (refreshWhenOpen === undefined || refreshWhenOpen === true) {
      const _keyword = useUrlQuery ? urlQuery.get('q') : ''
      const _pageIndex = parseInt(
        (useUrlQuery ? urlQuery.get('pageIndex') : '1') ?? '1'
      )
      setKeyword(_keyword)
      setPageIndex(_pageIndex)

      fetchData({
        [searchFields ?? 'filter']: noUrlQuery
          ? _keyword ?? undefined
          : undefined,
        ...searchData, //加入其他查询条件
        pageIndex: _pageIndex,
        pageSize: showPage ? currentPageSize : 1000,
        noPage: !showPage,
      })
    }
  }, [])
  const isNeedRefresh = (fieldName) => {
    const obj = searchItem?.find((c) => c.fieldName === fieldName)
    return obj?.enableRefresh
  }
  useEffect(() => {
    if (!isMounted()) return
    if (
      searchData &&
      (isNeedRefresh(searchData.__fieldName) ||
        searchData.__enableRefresh ||
        enableQueryOnSearchDataChange === undefined ||
        enableQueryOnSearchDataChange === true)
    ) {
      if (searchData.__enableRefresh) searchData.__enableRefresh = false
      if (searchData.__resetPageIndex) {
        query(1, undefined, true)
      } else {
        query(undefined, undefined, true)
      }
    }
  }, [searchData])
  const onSort = ({ key, sortUp }) => {
    const newsort = key + ' ' + (sortUp ? 'asc' : 'desc')
    setSort(newsort)
    query(undefined, newsort)
  }
  const query = async (
    page,
    newsort,
    useSearchData,
    pagesize,
    queryType,
    isAll = false
  ) => {
    const searchdata = searchData || {}
    //页码
    let pagenum = page
    if (pagenum !== undefined) setPageIndex(pagenum)
    else pagenum = pageIndex
    //每页行数
    let pageSize = pagesize
    if (pageSize !== undefined) setCurrentPageSize(pageSize)
    else pageSize = currentPageSize
    //过滤条件
    let x = {}
    if (!isAll) {
      if (queryType == 1 || (showKeyword && !useSearchData)) {
        x = {
          // ...searchdata,
          [searchFields ?? 'filter']: (keyword?.trim() || keyword) ?? undefined,
        }
      } else {
        x = {
          [searchFields ?? 'filter']: showKeyword
            ? (keyword?.trim() || keyword) ?? undefined
            : undefined,
          ...searchdata,
        }
      }
      x.sorting = newsort ? newsort : sort
    }
    x.pageIndex = pagenum
    x.pageSize = showPage ? pageSize : 1000
    x.noPage = !showPage
    await fetchData(x)
  }
  const handleQuery = (type) => {
    if (isLoading) {
      return
    }
    query(1, undefined, undefined, undefined, type)
    if (keyword !== null && keyword !== '') {
      if (noUrlQuery) urlQuery.set('q', keyword)
      urlQuery.delete('pageIndex')
    } else {
      urlQuery.delete('q')
      urlQuery.delete('pageIndex')
    }
    history.push(`${location.pathname}?${urlQuery.toString()}`)
  }
  const setCurrentPage = (page, pagesize) => {
    if (isLoading) {
      return
    }
    query(page, undefined, undefined, pagesize)
    if (page > 0) {
      if (noUrlQuery) urlQuery.set('pageIndex', page)
    } else {
      urlQuery.delete('pageIndex')
    }
    history.push(`${location.pathname}?${urlQuery.toString()}`)
  }
  const onSubmit = async (data, refresh = false) => {
    if (activDataIndex) {
      if (!refresh) {
        setActivDataIndex('')
        setFormData(null)
      }
      await onUpdateAndQuery()
    } else {
      await query(1)
      if (!isMounted()) return
      urlQuery.delete('pageIndex')
      history.push(`${location.pathname}?${urlQuery.toString()}`)
      onUpdate && onUpdate()
    }
    setActivDataIndex('')
    setFormData(null)
  }
  const onUpdateAndQuery = async (INDEX) => {
    if (INDEX) {
      await query(INDEX)
    } else {
      await query()
    }

    if (!isMounted()) return
    onUpdate && onUpdate()
  }
  const onDeleteConfirm = async () => {
    try {
      setIsDeleting(true)
      let TABLEPAGEINDEX = pageIndex
      const deleteInput = getDeleteInput
        ? getDeleteInput(deleteItem)
        : { ...(deleteItem || {}), id: deleteItem.id }
      let response
      if (!requestDelete) {
        response = await axios.delete(deleteData(deleteInput[keyField]))
      } else {
        response = await requestDelete(deleteInput)
      }
      if (!isMounted()) return
      if (response.status === 200 || response.status === 204) {
        setActivDataIndex('')
        setFormData(null)
        if (pageIndex != 1) {
          //非第一页删除
          let pageIndexMax = Math.ceil((listCount - 1) / currentPageSize)
          if (pageIndexMax < TABLEPAGEINDEX) {
            TABLEPAGEINDEX = pageIndexMax
            await setPageIndex(pageIndexMax)
          }
        }
        onDeleteData && onDeleteData(deleteItem)
        if (refreshAfterDelete === undefined || refreshAfterDelete)
          onUpdateAndQuery(TABLEPAGEINDEX)
        Message.success(t('t_hasDelete')) //`数据已删除`
      } else {
        Message.error(t('t_deleteFail')) //`删除失败`
      }
    } catch (e) {
      Message.warning(t('t_deleteFail')) //`删除失败`
    } finally {
      setDeleteItem(null)
      setIsDeleting(false)
    }
  }
  //批量删除
  const onBatchDeleteConfirm = async () => {
    try {
      setIsDeleting(true)
      let suc = 0,
        fail = 0
      let checkItemsLength = +checkItems.length + 0
      let TABLEPAGEINDEX = pageIndex
      let forIndex = requestBatchDelNoFor ? 1 : checkItems.length
      for (let i = 0; i < forIndex; i++) {
        const item = checkItems[i]
        const deleteInput = getDeleteInput ? getDeleteInput(item) : { ...item }
        let response
        if (!requestDelete) {
          response = await axios[batchDeleteRequestType](
            deleteData(deleteInput.id)
          )
        } else {
          response = await requestDelete(deleteInput)
        }
        if (!isMounted()) return
        if (response.status === 200 || response.status === 204) {
          let pageIndexMax = Math.ceil(
            (listCount - checkItemsLength) / currentPageSize
          )
          if (pageIndexMax < TABLEPAGEINDEX) {
            TABLEPAGEINDEX = pageIndexMax
            await setPageIndex(pageIndexMax)
          }
          setCheckItems([]) //重新初始化
          suc++
        } else {
          fail++
        }
      }

      if (suc > 0) Message.success(t('t_hasDelete')) //`数据已删除`
      if (fail > 0) Message.error(t('t_deleteFail')) //`删除失败`
      onBatchDeleteData && (await onBatchDeleteData(checkItems))
      onUpdateAndQuery(TABLEPAGEINDEX)
    } catch (e) {
      Message.warning(e?.error?.message ?? t('t_deleteFail')) //`删除失败`
    } finally {
      setIsDeleting(false)
      setShowBatchDel(false)
    }
  }
  //导出 todo
  const output = (option) => {
    onOutput && onOutput(option)
  }
  const inport = () => {
    console.log('run inport')
  }
  const refresh = () => {
    query()
  }
  const save = () => {
    //保存
    onSave && onSave(query)
  }
  const add = async (data, nullForm = false) => {
    if (nullForm) await setFormData(null)
    setDisabled(false)
    if (onAdd) {
      onAdd(_onAdd)
    } else {
      _onAdd(data)
    }
  }
  const edit = (item, index) => {
    setDisabled(false)
    showAndSwitchTab('0', item)
  }
  const _onShow = (item, index) => {
    if (dynamicDetailRoute) {
      if (onShow) {
        onShow(item, index)
        return
      }
      openDynamicDetail(getDynamicDetailAction('show'), item, {
        disabled: true,
        customTitle: onShowCustomTitle?.(item),
        title: titleField ? item?.[titleField] : undefined,
      })
      return
    }
    if (formRoute) {
      let data = {
        id: item[keyField],
        formData: item,
        event: null,
        disabled: true,
      }
      if (onShowCustomTitle) {
        data.customTitle = onShowCustomTitle(item)
      } else {
        data.title = titleField ? item?.[titleField] : undefined
      }
      if (onShow) {
        onShow(item, index)
      } else {
        dispatch(
          trigger({
            name: 'history.push',
            params: formRoute,
            data,
          })
        )
      }
    } else {
      if (onShow) {
        onShow(item, index)
      } else {
        setDisabled(true)
        showAndSwitchTab('0', item)
      }
    }
  }
  const _onEdit = (item, index) => {
    if (dynamicDetailRoute) {
      openDynamicDetail(getDynamicDetailAction('edit'), item, {
        disabled: false,
        customTitle: onEditCustomTitle?.(item),
        title: titleField ? item?.[titleField] : undefined,
      })
      return
    }
    if (formRoute) {
      let data = {
        id: item[keyField],
        formData: item,
        event: null,
        disabled: false,
      }

      if (onEditCustomTitle) {
        data.customTitle = onEditCustomTitle(item)
      } else {
        data.title = titleField ? item?.[titleField] : undefined
      }
      dispatch(
        trigger({
          name: 'history.push',
          params: formRoute,
          data,
        })
      )
    } else {
      if (onEdit) {
        onEdit(item, index, edit)
      } else {
        edit(item, index)
      }
    }
  }

  const _onAdd = (item) => {
    let resItem = item?.isEvent ? {} : item
    if (dynamicDetailRoute) {
      openDynamicDetail(getDynamicDetailAction('add'), resItem, {
        id: '',
        disabled: false,
        customTitle: onAddCustomTitle?.(),
        title: titleField ? item?.[titleField] : undefined,
      })
      return
    }
    if (formRoute) {
      let data = {
        id: '',
        formData: resItem, //item || null, 添加时会将事件对象传递至formData中，使用可能存在bug
        event: null,
        disabled: false,
      }
      if (onAddCustomTitle) {
        data.customTitle = onAddCustomTitle()
      } else {
        data.title = titleField ? item?.[titleField] : undefined
      }
      dispatch(
        trigger({
          name: 'history.push',
          params: formRoute,
          data,
        })
      )
    } else {
      setFormEvent({
        name: 'resetForm',
        params: [],
        callback: (initItem) => {
          const itemBefore = onAddBefore && onAddBefore()
          if (initItem || item || itemBefore) {
            const newformdata = { ...initItem, ...itemBefore, ...resItem } //, ...item
            setFormData(newformdata)
          }
          setShowSidePanel(true)
        },
      })
    }
  }

  const onUploadChange = (fileList, file) => {
    if (file?.status == 'init') {
      setIsLoading(true)
    }
    if (file?.status == 'error') {
      Notification.error({
        title: t('t_remind'),
        content: t('t_uploadFileFail'),
        showIcon: true,
        position: 'bottomRight',
        duration: 1500,
      })
      setIsLoading(false)
    }
    if (file?.status == 'done') {
      setIsLoading(false)
      if (file?.response?.success) {
        Notification.success({
          title: t('t_remind'),
          content: t('t_uploadFileSuccess'),
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        })
      } else {
        Notification.error({
          title: t('t_remind'),
          content: file?.response?.message,
          showIcon: true,
          position: 'bottomRight',
          duration: 1500,
        })
      }
      query(1)
    }
  }
  //工具栏选项
  const getToolsOption = () => {
    const toolOptions = {}
    for (const key in tools) {
      if (tools[key].left) {
        if (
          key !== 'add' &&
          key !== 'del' &&
          key !== 'output' &&
          key !== 'inport' &&
          key !== 'refresh' &&
          key !== 'upload'
        ) {
          toolOptions[key] = {
            ...tools[key],
            loading: isLoading,
            setIsLoading,
          }
        }
      }
    }
    if (canAdd && permCreate)
      //添加
      toolOptions['add'] = {
        text: tools?.add?.text ?? t('b_add'),
        show: tools?.add?.show ?? true,
        isLoading: tools?.add?.isLoading ?? undefined,
        type: tools?.add?.type ?? 'primary', //'default' | 'primary' | 'secondary' | 'dashed' | 'text' | 'outline';
        icon: tools?.add?.icon ?? <IconPlus />,
        disabled: tools?.add?.disabled ?? false,
        size: tools?.add?.size ?? searchPanelSize ?? 'small',
        index: tools?.add?.index ?? 'undefined',
        onClick: add,
      }
    if (canBatchDel && permDelete)
      //批量删除
      toolOptions['del'] = {
        text: tools?.del?.text ?? t('b_del'),
        show: tools?.del?.show ?? true,
        isLoading: tools?.del?.isLoading ?? undefined,
        type: tools?.del?.type ?? 'primary',
        status: 'danger', //'warning' | 'danger' | 'success' | 'default'
        icon: tools?.del?.icon ?? <IconDelete />,
        disabled: checkCanBatchDel
          ? checkCanBatchDel(checkItems)
          : !(checkItems && checkItems.length > 0),
        size: tools?.del?.size ?? searchPanelSize ?? 'small',
        index: tools?.del?.index ?? 'undefined',
        onClick: () => setShowBatchDel(true),
      }
    if (canOutput)
      //输出
      toolOptions['output'] = {
        text: tools?.output?.text ?? t('b_output'),
        show: tools?.output?.show ?? true,
        isLoading: tools?.output?.isLoading ?? undefined,
        type: tools?.output?.type ?? 'default',
        icon: tools?.output?.icon ?? <IconExport />,
        disabled: tools?.output?.disabled ?? false,
        size: tools?.output?.size ?? searchPanelSize ?? 'small',
        index: tools?.output?.index ?? 'undefined',
        onClick: tools?.output?.onClick ?? output,
      }
    if (canUpload) {
      //上传文件
      toolOptions['upload'] = {
        text: tools?.upload?.text ?? t('b_inport'),
        show: tools?.upload?.show ?? true,
        isLoading: tools?.upload?.isLoading ?? undefined,
        type: tools?.upload?.type ?? 'default',
        icon: tools?.upload?.icon ?? <IconImport />,
        disabled: tools?.upload?.disabled ?? false,
        size: tools?.upload?.size ?? searchPanelSize ?? 'small',
        index: tools?.upload?.index ?? 'undefined',
        action: tools?.upload?.action ?? '',
        name: tools?.upload?.name ?? '',
        accept: tools?.upload?.accept ?? '',
        render: (i, data) => {
          return (
            <Upload
              className="customUpload"
              name={data.name || 'files'}
              headers={{ Authorization: 'Bearer ' + token }}
              disabled={data.disabled}
                          action={apiBaseUrl + data.action}
              showUploadList={false}
              accept={data.accept}
              onChange={onUploadChange}
            >
              <Button size="small" icon={data.icon}>
                {data.text}
              </Button>
            </Upload>
          )
        },
      }
    }
    if (canRefresh)
      //刷新
      toolOptions['refresh'] = {
        text: tools?.refresh?.text ?? t('b_refresh'),
        show: tools?.refresh?.show ?? true,
        isLoading: tools?.refresh?.isLoading ?? undefined,
        type: tools?.refresh?.type ?? 'default',
        icon: tools?.refresh?.icon ?? <IconRefresh />,
        disabled: tools?.refresh?.disabled ?? false,
        size: tools?.refresh?.size ?? searchPanelSize ?? 'small',
        index: tools?.refresh?.index ?? 'undefined',
        onClick: refresh,
      }
    if (canInport)
      //导入
      toolOptions['inport'] = {
        text: tools?.inport?.text ?? t('b_inport'),
        show: tools?.inport?.show ?? true,
        isLoading: tools?.inport?.isLoading ?? undefined,
        type: tools?.inport?.type ?? 'default',
        icon: tools?.inport?.icon ?? <IconImport />,
        disabled: tools?.inport?.disabled ?? false,
        size: tools?.inport?.size ?? searchPanelSize ?? 'small',
        index: tools?.inport?.index ?? 'undefined',
        onClick: inport,
      }
    if (canSave)
      //导入
      toolOptions['save'] = {
        text: tools?.save?.text ?? t('b_save'),
        show: tools?.save?.show ?? true,
        isLoading: tools?.save?.isLoading ?? undefined,
        type: tools?.save?.type ?? 'primary',
        icon: tools?.save?.icon ?? <IconSave />,
        disabled: tools?.save?.disabled ?? false,
        size: tools?.save?.size ?? searchPanelSize ?? 'small',
        index: tools?.save?.index ?? 'undefined',
        onClick: save,
      }
    for (const key in tools) {
      if (!tools[key].left) {
        if (
          key !== 'add' &&
          key !== 'del' &&
          key !== 'output' &&
          key !== 'inport' &&
          key !== 'refresh' &&
          key !== 'upload'
        ) {
          toolOptions[key] = {
            ...tools[key],
            loading: isLoading,
            setIsLoading,
          }
        }
      }
    }
    return toolOptions
  }
  const toolOptions = getToolsOption()

  const setShowSidePanel = (visible) => {
    if (visible)
      setFormEvent({
        name: 'showAndSwitchTab',
        params: ['0'],
      })
    else
      setFormEvent({
        name: 'setShowSidePanel',
        params: [visible],
      })
  }
  const changeData = (newData) => {
    setList(
      list.map((d) =>
        d[keyField] === newData[keyField]
          ? {
            ...d,
            ...newData,
          }
          : d
      )
    )
  }
  const showAndSwitchTab = (tabIndex, item) => {
    setActivDataIndex(item[keyField])
    setFormData(item)
    setFormEvent({
      name: 'showAndSwitchTab',
      params: [tabIndex],
    })
  }
  const _onSelectionChange = async (items) => {
    let resItems = cloneDeep(items)
    if (onSelectionChangeBefore) {
      resItems = await onSelectionChangeBefore(resItems, setSelectedRowKeys)
    }
    setCheckItems(resItems)
    onSelectionChange && onSelectionChange(resItems)
  }
  const hasTool = () => {
    return Object.keys(toolOptions).length > 0 || toolChildren
  }
  const toolsPanel = hasTool() && (
    <ToolPanel
      options={toolOptions}
      className={toolClassName}
      sizeClass={tableSize}
    >
      {toolChildren}
    </ToolPanel>
  )

  const searchPanel = (
    <SearchPanel
      showSearchButton={showSearchButton}
      onQuery={(type) => handleQuery(type)}
      className={searchClassName}
      searchItem={searchItem}
      initData={searchInitData}
      newFormData={JSON.stringify(searchData) == '{}' ? undefined : searchData}
      onChange={onSearchDataChange}
      labelCol={searchLabelCol}
      wrapperCol={searchWrapperCol}
      simpleSearch={simpleSearch}
      setShowKeyword={setShowKeyword}
      showKeyword={showKeyword}
      keyword={keyword}
      setKeyword={setKeyword}
      tools={toolsPanel}
      toolWidth={toolWidth}
      canSearch={canSearch}
      event={searchEvent}
      sizeClass={searchPanelSize}
      simpleSearchInputWidth={simpleSearchInputWidth}
      searchPlaceholder={searchPlaceholder}
      simpleSearchProps={simpleSearchProps}
    />
  )
  useEffect(() => {
    if (HeadHeightRef?.current) {
      let newHeadheight = HeadHeightRef?.current?.clientHeight + 14 ?? 40
      setHeadHeight(newHeadheight)
    }
  }, [
    HeadHeightRef,
    hasHeader,
    showKeyword,
  ])
  const header = hasHeader && (
    <div style={{ zIndex: 9 }} ref={HeadHeightRef}>
      {renderCustomerHeader && renderCustomerHeader(toolsPanel, searchPanel)}
      {!renderCustomerHeader && (
        <div style={{ padding: '6px 0px' }}>{searchPanel}</div>
      )}
    </div>
  )

  const getCommonTableWidth = () => {
    const width =
      tableWidth === undefined
        ? clientWidth -
        (leftPanelWidth ?? 0) -
        (rightPanelWidth ?? 0) -
        (menuCollapsed ? 48 : menuWidth ?? 200) -
        32 - //左右边距
        60 //滚动条宽度
        : tableWidth
    return width < 200 ? 200 : width
  }
  const clearSelected = () => {
    setSelectedRowKeys([])
  }
  const getSelectedRowKeys = () => {
    return selectedRowKeys
  }
  const getListData = () => {
    return list || []
  }
  const onChangeLoading = (loadingStatus) => {
    setIsLoading(loadingStatus)
  }

  const commonTableWidth = getCommonTableWidth()
  const renderBody = (
    <div>
      <Layout>
        <Layout>
          {leftPanel && (
            <Layout.Sider
              width={
                innerLeftSiderWidth > 0 ? innerLeftSiderWidth : leftPanelWidth
              }
              style={{
                minWidth: 100,
                maxWidth: 600,
                height: siderHeight
                  ? siderHeight
                  : (wrapHeight ?? clientHeight) -
                  (showNavbar ? 60 : 0) - //头部
                  28 - //面包屑
                  4 - //上边距
                  16 - //下边距
                  32 - //内边距
                  40 - //导航页签
                  (hasHeader ? headHeight : 0) - //头部查询
                  (showFooter ? 20 : 0) - //底部
                  4 + //补偿值
                  compensateHeight,
              }}
              resizeBoxProps={{
                directions: directions,
                onMoving: (e, { width, height }) => {
                  if (width > 100 && width < 600) setInnerLeftSiderWidth(width)
                },
              }}
            >
              {leftPanel}
            </Layout.Sider>
          )}
          <Layout.Content style={{ height: '100%' }}>
            <div>
              <CommonTable
                isLoading={isLoading}
                zebra={false}
                size={tableSize}
                columns={columns}
                data={list}
                showOperationCol={showOperationCol}
                canShow={canShow || (canEdit && !permUpdate)}
                onShow={_onShow}
                canEdit={canEdit && permUpdate}
                onEdit={_onEdit}
                canEditText={canEditText}
                canShowText={canShowText}
                canDelete={canDelete && permDelete}
                actionRender={actionRender}
                onDelete={(item) => setDeleteItem(item)}
                showPage={showPage}
                sizeOptions={sizeOptions}
                onGotoPage={(page, pageSize) => setCurrentPage(page, pageSize)}
                rowCount={listCount}
                currentPage={pageIndex}
                currentPageSize={currentPageSize}
                otherMenu={otherMenu}
                operationCol={operationCol}
                enableSorting={enableSorting}
                onSort={onSort}
                onOperateButtonCount={onOperateButtonCount}
                height={
                  tableHeight !== undefined
                    ? tableHeight
                    : tableHeightControl
                      ? (wrapHeight ?? clientHeight) -
                      (showNavbar ? 60 : 0) - //头部
                      28 - //面包屑
                      4 - //上边距
                      16 - //下边距
                      32 - //内边距
                      40 - //导航页签
                      (hasHeader ? headHeight : 0) - //头部查询
                      tableHeadHeight - //标题栏
                      (showPage ? 30 : 0) - //翻页
                      (showFooter ? 20 : 0) - //底部
                      (title ? 46 : 0) - //card title
                      18 + //补偿值
                      compensateHeight +
                      (list.length ? (showPage ? 0 : 20) : 48) - //当前没数据时增加48px的高度占位
                      footerHeight
                      : undefined
                }
                width={commonTableWidth}
                canSelection={canSelection || (canBatchDel && permDelete)}
                onSelectionChange={_onSelectionChange}
                multipleChoice={multipleChoice}
                keyField={keyField}
                checkCanDelete={checkCanDelete} //检查当前行是否可删除
                checkCanEdit={checkCanEdit} //检查当前行是否可编辑
                checkCanShow={checkCanShow} //检查当前行是否可查看
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                onContextMenu={(item, index, event) => {
                  if (curContextMenu.length > 0) {
                    event.preventDefault()
                    setContextMenuState({
                      visible: true,
                      top: event.clientY - 115,
                      left: event.clientX + 5,
                      item: item,
                    })
                  }
                }}
                highlightRow={highlightRow}
                selectedRowKeys={selectedRowKeys}
                renderSumary={renderSumary}
                onHeadHeightChange={(height) => {
                  setTableHeadHeight(height)
                }}
                needNum={needNum}
                onExpand={onExpand}
                expandedRowKeys={expandedRowKeys}
                checkboxProps={checkboxProps}
                onRowCheckClick={onRowCheckClick}
                useRowCheckClick={useRowCheckClick}
                paginationSimple={paginationSimple}
                paginationSizeCanChange={paginationSizeCanChange}
                locale={locale}
                {...tableProps}
              />
              <ContexMenu
                visible={contextMenuState.visible}
                onVisibleChange={() => setContextMenuState({ visible: false })}
                menu={curContextMenu}
                top={contextMenuState.top}
                left={contextMenuState.left}
                item={contextMenuState.item}
              />
            </div>
          </Layout.Content>
          {rightPanel && (
            <Layout.Sider
              width={
                innerRightSiderWidth > 0
                  ? innerRightSiderWidth
                  : rightPanelWidth
              }
              style={{ minWidth: 100, maxWidth: 600 }}
              resizeBoxProps={{
                directions: ['left'],
                onMoving: (e, { width, height }) => {
                  if (width > 100 && width < 600) setInnerRightSiderWidth(width)
                },
              }}
            >
              {rightPanel}
            </Layout.Sider>
          )}
        </Layout>
        {footer && <Layout.Footer>{footer}</Layout.Footer>}
      </Layout>
    </div>
  )
  const renderEdit = (canAdd || canShow || canEdit) && FormEdit && (
    <FormEdit
      keyField={keyField}
      formData={formData}
      onCancel={() => {
        setActivDataIndex('')
        setFormData(null)
      }}
      id={activDataIndex}
      onSubmit={onSubmit}
      event={formEvent}
      disabled={
        formDisabled ||
        disabled ||
        !((permCreate && !formData?.id) || (permUpdate && formData?.id))
      }
      extraData={extraData}
    />
  )
  const renderDel = canDelete && permDelete && (
    <CommonConfirm
      title={t('t_titleDeleteData')}
      content={t('t_confirmDeleteData')}
      isVisible={deleteItem != null}
      onConfirm={onDeleteConfirm}
      confirmText={t('b_confirm')}
      onCancel={() => setDeleteItem(null)}
      isLoading={isDeleting}
    />
  )
  const renderBatchDel = canBatchDel && permDelete && (
    <CommonConfirm
      title={t('t_titleDeleteData')}
      content={t('t_confirmDeleteData')}
      isVisible={showBatchDel}
      onConfirm={onBatchDeleteConfirm}
      confirmText={t('b_confirm')}
      onCancel={() => setShowBatchDel(false)}
      isLoading={isDeleting}
    />
  )
  const onInit = () => {
    //清空数据并且清空数据总数
    setList([])
    setListCount(0)
    clearSelected()
  }
  const getCheckItems = () => {
    return checkItems
  }
  useImperativeHandle(ref, () => ({
    query, //刷新数据
    changeData, //修改列表数据
    showAndSwitchTab, //显示边栏并切换tab
    setShowSidePanel,
    setList, //设置数据
    setDeleteItem,
    add,
    edit,
    openDynamicDetail,
    clearSelected,
    getListData,
    onChangeLoading,
    setSelectedRowKeys,
    getSelectedRowKeys,
    onInit,
    getCheckItems,
  }))
  if (!configuration?.auth?.grantedPolicies) {
    return <div className={className}>{t('t_page_is_loading')}...</div>
  }
  if (!permList) {
    return <div className={className}>{t('t_unauth_page')}</div>
  }
  return (
    <Card
      style={{ width: '100%', borderRadius: '5px' }}
      className={className}
      bordered={bordered}
      hoverable={hoverable}
      bodyStyle={bodyStyle}
      title={title ? InitCardTitle(title) : null}
      size={cardSize}
    >
      {header}
      {renderBody}
      {renderEdit}
      {renderDel}
      {renderBatchDel}
    </Card>
  )
}

const __LoongInCommonIndex = forwardRef(_LoongInCommonIndex)
export const LoongInCommonIndex = memo(__LoongInCommonIndex)

